module.exports = __webpack_public_path__ + "img/0_icon-zb-l.5cc93ae2.svg";